import icon from 'vue-svgicon';

icon.register({
    'bold/view-off': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.2 10.549a20.954 20.954 0 0 0-4.3-3.6l4-3.995a1 1 0 1 0-1.414-1.414l-.018.018a.737.737 0 0 1-.173.291l-19.5 19.5c-.008.007-.018.009-.026.017A1 1 0 0 0 3.4 22.454l4.146-4.146a11.26 11.26 0 0 0 4.31.939h.3c4.256 0 8.489-2.984 11.051-5.8a2.171 2.171 0 0 0-.007-2.898zm-6.887 2.721a4.581 4.581 0 0 1-3 3.028 4.3 4.3 0 0 1-3.1-.19.253.253 0 0 1-.068-.407l5.56-5.559a.252.252 0 0 1 .407.067 4.3 4.3 0 0 1 .201 3.061zM7.615 13.4a.244.244 0 0 0 .061-.24A4.315 4.315 0 0 1 7.5 12 4.5 4.5 0 0 1 12 7.5a4.276 4.276 0 0 1 1.16.173.244.244 0 0 0 .24-.062l1.941-1.942a.254.254 0 0 0-.1-.421A10.413 10.413 0 0 0 12 4.75C7.7 4.692 3.4 7.7.813 10.549a2.15 2.15 0 0 0-.007 2.9 21.209 21.209 0 0 0 3.438 3.03.256.256 0 0 0 .326-.029z"/>`,
    },
});
